//import Home from "@/views/Home";
import NotFound from "@/views/NotFound";
import DisabledWebshop from "@/views/DisabledWebshop";
import Maintenance from "@/views/Maintenance";
import Klas from "@/views/Klas";
import Cataloog from "@/views/Cataloog";
import BestelOverzicht from "@/views/BestelOverzicht";
import BetaalFormulier from "@/views/BetaalFormulier";
import Betalen from "@/views/Betalen";
import Bevestiging from "@/views/Bevestiging";
import PaymentSuccess from "@/views/PaymentSuccess";
import PaymentFailed from "@/views/PaymentFailed";
import PomBevestiging from "@/views/PomBevestiging";
import Failed from "@/views/Error";
import Print from "@/views/Print";
import store from "@/store";

export default [
  {
    name: "home",
    path: "/",
    //component: Home,
    redirect: { name: "klas" },
  },
  // klas
  {
    name: "klas",
    path: "/klas/:klasId?",
    component: Klas,
    props: () => {
      const urlParams = new URLSearchParams(window.location.search);
      const klasId = urlParams.get("klas") || store.state.orders.order.klasId;
      return { klasId };
    },
    meta: {
      requiresOpenOrder: true,
    },
  },
  // cataloog
  {
    name: "cataloog",
    path: "/cataloog/:klasId/",
    component: Cataloog,
    props: (to) => {
      let klas = store.getters["data/findKlas"](to.params.klasId);
      const display = to.query.display || "list";
      return { klas, display };
    },
    meta: {
      requiresValidKlas: true,
      requiresOpenOrder: true,
    },
    async beforeEnter(to) {
      let klasId = to.params.klasId || to.query.klas;
      if (!store.getters["data/findKlas"](klasId)) {
        console.warn("invalid klas, redirecting to klas route", { url: location.href, route: { ...to } });
        return { name: "klas" };
      }
      if (klasId !== store.state.orders.order.klasId) {
        await store.dispatch("orders/submitKlas", { klasId });
      }
    },
  },
  // besteloverzicht
  {
    name: "besteloverzicht",
    path: "/besteloverzicht",
    component: BestelOverzicht,
    meta: {
      requiresValidKlas: true,
      requiresValidOrderlines: true,
      requiresOpenOrder: true,
    },
  },
  // betaalformulier
  {
    name: "betaalformulier",
    path: "/contact",
    component: BetaalFormulier,
    meta: {
      requiresValidKlas: true,
      requiresValidOrderlines: true,
      requiresOpenOrder: true,
    },
  },
  // betalen
  {
    name: "betalen",
    path: "/betalen",
    component: Betalen,
    meta: {
      requiresValidKlas: true,
      requiresValidOrder: true,
      requiresOpenOrder: true,
    },
  },
  // bevestiging
  {
    name: "bevestiging",
    path: "/bevestiging",
    component: Bevestiging,
    redirect: () => (store.getters["orders/isPaid"] ? { name: "paymentSuccess" } : { name: "paymentFailed" }),
    meta: {
      requiresValidKlas: true,
      requiresValidOrder: true,
      requiresPaymentStatus: true,
    },
    children: [
      {
        name: "paymentSuccess",
        path: "success",
        component: PaymentSuccess,
      },
      {
        name: "paymentFailed",
        path: "mislukt",
        component: PaymentFailed,
      },
      {
        name: "pom",
        path: "pom",
        component: PomBevestiging,
        meta: {
          requiresAppId: false,
          requiresValidKlas: false,
          requiresValidOrder: false,
          requiresOpenOrder: false,
          requiresPaymentStatus: false,
          disableNavigation: true,
          webshopTitle: "Verwerking betaling",
        },
      },
    ],
  },
  {
    name: "print",
    path: "/afdrukken",
    component: Print,
    meta: {
      requiresClosedOrder: true,
    },
  },
  {
    name: "error",
    path: "/fout",
    component: Failed,
    props: true,
    meta: {},
  },
  {
    name: "disabled-webshop",
    path: "/uitgeschakeld",
    component: DisabledWebshop,
    meta: {},
  },
  {
    name: "maintenance",
    path: "/onderhoud",
    component: Maintenance,
    meta: {},
  },
  {
    name: "notFound",
    path: "/404",
    component: NotFound,
    props: (to) => ({ url: to.query.url }),
    meta: {},
  },
  {
    name: "catchAll",
    path: "/:notFound(.*)",
    redirect: (from) => ({ name: "notFound", query: { url: from.fullPath } }),
    meta: {},
  },
];
